import { render, staticRenderFns } from "./DialogKasbon.vue?vue&type=template&id=3c542921"
import script from "./DialogKasbon.vue?vue&type=script&lang=js"
export * from "./DialogKasbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports